var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHospitalinfoAnesthesiologist = function SvgHospitalinfoAnesthesiologist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M24.304 11.934 20.06 7.69 7.333 20.42l4.243 4.243z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6726",
    d: "m28.194 4.51-.707-.707-4.243 4.242.707.707z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "m24.31 9.098-1.415-1.414-1.414 1.414 1.414 1.414z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6726",
    d: "m10.88 23.95-2.83-2.83-2.13 2.13-1.41-1.42-.71.71 5.66 5.66.71-.71-1.42-1.41z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4C4C4C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.097 11.672-.53.53 2.121 2.122.53-.53zM13.968 13.797l-.53.53 2.122 2.121.53-.53zM11.847 15.917l-.53.53 2.121 2.122.53-.53z"
  }))));
};
export default SvgHospitalinfoAnesthesiologist;